import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

import { LicensesPage } from "@/features/licenses/licenses-page";

/**
 * Arama parametreleri, müşteri listesindeki "Lisans üret" kısayolu için.
 * Tek seferliktirler: sayfa açılınca tüketilip adres çubuğundan temizlenirler,
 * yoksa yenilemede diyalog tekrar açılırdı.
 */
const searchSchema = z.object({
  musteri: z.string().uuid().optional().catch(undefined),
  yeni: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute("/_authed/lisanslar")({
  validateSearch: searchSchema,
  component: LicensesRoute,
});

function LicensesRoute() {
  const { musteri, yeni } = Route.useSearch();
  const navigate = useNavigate();

  return (
    <LicensesPage
      initialCustomerId={musteri}
      openNewOnMount={yeni === true}
      onConsumeInitialParams={() =>
        void navigate({ to: "/lisanslar", search: {}, replace: true })
      }
    />
  );
}
